import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import {
  ScheduleOutlined,
  AuditOutlined,
  FileDoneOutlined,
  ContactsOutlined,
} from '@ant-design/icons';

import { DogParkRoutes } from 'dogpark/utilities/const';
import { getLeashContentStorage } from 'leash/utilities/localStorage/leashContentStorage';
import { LeashRoutes } from 'leash/utilities/const';
import { getPricingContentStorage } from 'pricing/utilities/localStorage/pricingContentStorage';
import { PricingRoutes } from 'pricing/types';
import { getPupDocsContentStorage } from 'pupdocs/utilities/localStorage/pupDocsContentStorage';
import { PupDocsRoutes } from 'pupdocs/utilities/const';
import { ReactComponent as PuppySpotLogo } from 'shared/components/layout/puppyspot.svg';
import { AppNames } from 'types';
import {
  ApplicationItemStyled,
  ApplicationItemTitleStyled,
  IconContainerStyled,
  TextContainerStyled,
} from './Dashboard.styles';

type Props = {
  appName: AppNames;
  legend: string;
};

export const DashboardApp = ({ appName, legend }: Props): ReactElement => {
  const history = useHistory();
  const fetchContentAndNavigate = async () => {
    switch (appName) {
      case 'Leash':
        await getLeashContentStorage();
        history.push(LeashRoutes.Packages);
        break;
      case 'PupDocs':
        await getPupDocsContentStorage();
        history.push(PupDocsRoutes.PreFlight);
        break;
      case 'Pricing':
        await getPricingContentStorage();
        history.push(PricingRoutes.ContractList);
        break;
      case 'DogPark':
        history.push(DogParkRoutes.Breeders);
        break;
      default:
        break;
    }
  };

  const defineIconPerApplication = () => {
    if (appName === 'Pricing') {
      return <AuditOutlined />;
    }

    if (appName === 'PupDocs') {
      return <FileDoneOutlined />;
    }

    if (appName === 'DogPark') {
      return <ContactsOutlined />;
    }

    return <ScheduleOutlined />;
  };

  const getColor = () => {
    if (appName === 'Pricing') {
      return 'linear-gradient(0deg, #3f526e, #3f526e), #66af37';
    }

    if (appName === 'PupDocs') {
      return '#745072';
    }

    if (appName === 'DogPark') {
      return '#A65B5B';
    }

    return '';
  };

  return (
    <ApplicationItemStyled onClick={fetchContentAndNavigate} data-testid={appName}>
      <IconContainerStyled color={getColor()}>
        {defineIconPerApplication()}
      </IconContainerStyled>
      <TextContainerStyled>
        <div>
          <PuppySpotLogo />
          <div>
            <span>|</span>
            <span>{appName}</span>
          </div>
        </div>
        <ApplicationItemTitleStyled>{legend}</ApplicationItemTitleStyled>
      </TextContainerStyled>
    </ApplicationItemStyled>
  );
};
